var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-checkbox-group', _vm._g(_vm._b({ model: { value: _vm.formValue[_vm.config.prop], callback: function callback($$v) {
        _vm.$set(_vm.formValue, _vm.config.prop, $$v);
      }, expression: "formValue[config.prop]" } }, 'el-checkbox-group', _vm.config.params, false), _vm.$listeners), _vm._l(_vm.tagList, function (opt) {
    return _c('el-checkbox', { key: opt.value, attrs: { "label": opt.value, "border": opt.border, "disabled": opt.disabled } }, [_vm._v(_vm._s(opt.label))]);
  }), 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };